import { useAuth } from "context/AuthContext";
import { useEffect, useState } from 'react';
import { SubmitHandler, useForm } from "react-hook-form";
import axiosInstance from 'services/axiosInstance';
import * as S from './style';
import { NumericFormat } from "react-number-format";
//Components
import LayoutDefault from '../../../LayoutModal/LayoutDefault';
import Loading from "../../../Loading";
import CreditStorePayment from '../../Payment/Crediario';
import AuthPromotion from "../Auth";
import CreditCard from "../../../../components/Modals/Payment/CreditCard";
//hooks
import useLoading from '../../../../hooks/useLoading';
import { useMultipleModal } from '../../../../hooks/useMultipleModal';
//utils
import { CurrencyFormat, formatPercentage } from 'utils/CurrencyFormat';
//icons
import { CaretDown, CaretUp, X } from '@phosphor-icons/react';
//Interface
import { IPromotion } from 'Interfaces/IPromotion';
import { ICard } from "Interfaces/ICard";
import {
    IProps,
    IPromo,
    IPromotionSelected,
    IPaymentItem,
    Inputs
} from "Interfaces/IPromoPay";
import { IMethPay } from "Interfaces/IMethodPaym";

export default function Promocao({
    isOpenModals,
    setModalClose,
    type,
    id,
    dataPayment
}: IProps) {

    const {
        setValue,
        register,
        watch,
        reset,
        getValues,
        resetField,
        control,
        handleSubmit,
        formState: { errors },
    } = useForm<Inputs>({
        defaultValues: {
            payments: {
                to_receive: "",
                payment_method_id: 0,
                down_payment: "",
                down_payments: [],
                first_due_date: "",
                payment_credit_installment: 0
            }
        }
    });

    const UserAuthenticated = useAuth();
    const idUserAuth = UserAuthenticated?.user?.id;
    const [data, setData] = useState<IPromo[]>([]);
    const [promoSelected, setPromoSelected] = useState<IPromotion | null>(null);
    const [card, setCard] = useState<ICard[]>([]);
    const { isLoading, startLoading, stopLoading } = useLoading();
    const { isOpenModal, toggleModalVisibility } = useMultipleModal();
    const {
        isLoading: isLoadingModal,
        startLoading: startLoadingModal,
        stopLoading: stopLoadingModal
    } = useLoading();
    const [priceProduct, setPriceProduct] = useState('0');
    const [selectedPercent, setSelectedPercent] = useState<number>(0);
    const [discountPersonalized, setDiscountPersonalized] = useState<number>(0);
    const [paymentMethod, setPaymentMethod] = useState<IMethPay[]>([]);
    const [isAuthenticatedForPromotion, setIsAuthenticatedForPromotion] = useState(false);
    const [idUser, setIdUser] = useState<number | null>(null);
    const [isAuth, setIsAuth] = useState<boolean>(true);
    const [minimumValue, setMinimumValue] = useState('0');
    const [isAuthValueMinumum, setIsAuthValueMinumum] = useState<boolean>(false);

    const [itemsPromotion, setItemsPromotion] = useState<IPromotionSelected>({
        promotions: null,
        payments: [],
    });

    useEffect(() => {
        const fetchData = async () => {
            startLoadingModal();
            try {
                const url = type === 'acessories' ? 'accessory' : type;
                const [response, responsePay, responseCard] = await Promise.all([
                    axiosInstance.get(`${url}/${id}?userId=${idUserAuth}`),
                    axiosInstance.get('payment-method'),
                    axiosInstance.get('find-all'),
                ])
                const responseProduct = response.data;
                const promotionData = responseProduct.promotion_items || [];
                setMinimumValue(responseProduct?.minimum_value || '0');
                setPriceProduct(responseProduct.price)
                toggleModalVisibility('section-promo');

                setData(promotionData);
                setPaymentMethod(responsePay.data);
                setCard(responseCard.data);
            } catch (error) {
                console.error("Erro ao obter dados:", error);
            } finally {
                stopLoadingModal();
            }
        };

        if (id !== null && type) {
            fetchData();
        }
    }, [id, type, isOpenModals]);

    //função para esconder seção
    const handleVisibleSection = (type: string) => {
        toggleModalVisibility(type);
    }

    //Função para lidar com a seleção de promoção
    const handlePromotion = (promotion: IPromotion) => {
        setIsAuth(true);
        setDiscountPersonalized(0);
        setSelectedPercent(0);
        const needsAuth = promotion.auth.toLowerCase() === 'administrador' || promotion.auth.toLowerCase() === 'gerente';

        if (needsAuth) {
            if (isAuthenticatedForPromotion) {
                // Usuário já está autenticado, pode aplicar a promoção diretamente
                setIsAuth(true);
            } else {
                // Precisa autenticar primeiro
                toggleModalVisibility("auth-promo");
                setIsAuth(false);
                return; // Não aplica a promoção ainda
            }
        }

        setPromoSelected(promotion);
        setItemsPromotion({
            promotions: {
                promotion_id: promotion.id || null,
                title: promotion.title || '',
                paymentable_id: null,
                paymentable_type: '',
                personalized_discount: null
            },
            payments: [],
        });
    }

    // Quando o usuário for autenticado com sucesso
    const handleAuthSuccess = (userId: number) => {
        setIdUser(userId);
        setIsAuth(true);
        toggleModalVisibility('auth-promo');
        setIsAuthenticatedForPromotion(true);
    };

    // Quando o usuário for autenticado com sucesso com valor minimo
    const handleAuthSuccessMinumum = (userId: number) => {
        if (userId) {
            setIsAuthValueMinumum(true);
            toggleModalVisibility('auth-valuemin');
        }
    };

    //formatar promoção
    const formatPromotion = (promotions: any) => {
        const parts: string[] = [];

        // 💰 Pagamentos à vista
        if (promotions.cash_promotions?.length) {
            promotions.cash_promotions.forEach((p: any) => {
                parts.push(`${p.payment_method?.payment_method || '-'} ${formatPercentage(p.discount || 0)}`);
            });
        }

        // 💳 Crédito (pegar o desconto da 1ª parcela, ou pode definir regra diferente)
        if (promotions.credit_promotions?.length) {
            const credit = promotions.credit_promotions.find((c: any) => c.installment === 1);
            if (credit) parts.push(`Crédito ${formatPercentage(credit.discount || 0)}`);
        }

        // 📄 Crediário
        if (promotions.payment_credit_promotion) {
            parts.push(`Crediário ${parseFloat(formatPercentage(promotions.payment_credit_promotion[0]?.discount || 0))}`);
        }

        return parts.join(" | ");
    }

    // Lidar com a forma de pagamento selecionada
    const handlePayment = (
        id: number,
        payment_method_id: number,
        name: string,
        discount: string,
        type: string,
        installment?: number, // aqui vem a parcela se for promoção
    ) => {
        const paymentName = name.toLocaleLowerCase();
        setDiscountPersonalized(0);

        // Verifica se o método já foi adicionado e é "Crediário da loja"
        const isCrediario = paymentName === 'crediário' || paymentName === 'crediário da loja';
        const alreadyExists = itemsPromotion.payments.some(
            p => p.payment_method_id === payment_method_id && isCrediario
        );

        if (isCrediario && alreadyExists) {
            alert("Você já adicionou o método 'Crediário da loja'.");
            return;
        }

        let updatedPayments: IPaymentItem[] = [];

        if (payment_method_id && name) {
            let taxa = "0";
            let idCredit = null;

            // ⚡ Promoção no cartão → já calcula taxa com base na parcela recebida
            if (paymentName === "cartão de crédito" && installment) {
                const { interestRate: taxaCalc, id_parcela } = calculateTaxa(
                    Number(priceProduct), // valor total da venda
                    installment,          // número de parcelas
                    null                  // não tem id porque veio da promoção
                );
                taxa = taxaCalc.toFixed(2);
                idCredit = id_parcela || null;
            }

            // Adiciona pagamento
            updatedPayments = [
                ...itemsPromotion.payments,
                {
                    name: paymentName,
                    discount: discount,
                    payment_method_id: payment_method_id,
                    amount: null,
                    installment_on_credit_card_id: idCredit, // só manual preenche isso
                    parcela: installment || 0,           // promoção preenche aqui
                    taxa,                                // já salva taxa se veio de promoção
                    paymentable_id: id,
                    paymentable_type: type
                }
            ];
        } else {
            // Remove pagamento
            updatedPayments = itemsPromotion.payments.filter(
                p => p.payment_method_id !== payment_method_id
            );
        }

        // Se for apenas um pagamento → já define o valor total
        if (updatedPayments.length === 1) {
            const valor = Number(priceProduct) || 0;
            const valueTotal = valor - (valor * Number(discount) / 100);
            updatedPayments[0].amount = valueTotal;
        }

        setItemsPromotion(prev => ({
            ...prev,
            payments: updatedPayments
        }));

        findDiscount(updatedPayments);
    };

    // Função para REMOVER UM PAGAMENTO específico
    const handleRemovePayment = (index: any) => {
        const updatedPayments = itemsPromotion.payments.filter((_, i) => i !== index);

        setItemsPromotion(prev => ({
            ...prev,
            payments: updatedPayments
        }));

        // Atualiza desconto para pagamentos restantes
        findDiscount(updatedPayments);
    };

    // Encontrar o menor desconto e atualizar a promoção
    const findDiscount = (payments: IPaymentItem[] = itemsPromotion.payments) => {
        if (payments.length === 0) {
            setSelectedPercent(0);
            return;
        }

        // Converte todos os descontos para número
        const discounts = payments.map((item) =>
            item.discount ? Number(item.discount || 0) : 0
        );

        const menorDesconto = Math.min(...discounts);

        setSelectedPercent(menorDesconto);

        // Localiza o objeto da payment que tem esse desconto
        const paymentMenor = payments.find(
            (item) => Number(item.discount) === menorDesconto
        );

        if (paymentMenor) {
            setItemsPromotion(prev => ({
                ...prev,
                promotions: {
                    title: prev.promotions?.title ?? null,
                    personalized_discount: menorDesconto.toString() || null,
                    promotion_id: prev.promotions?.promotion_id ?? null,
                    paymentable_id: paymentMenor.paymentable_id,
                    paymentable_type: paymentMenor.paymentable_type,
                },
            }));
        }
    };

    // Função utilitária para unificar os métodos
    const getPaymentOptions = (promoSelected: any) => {
        if (!promoSelected) {
            const payment = paymentMethod.map((item) => ({
                id: null,
                payment_method_id: item.id,
                name: item.payment_method || "-",
                discount: 0,
                installment: null,
                type: null
            }));
            return payment;
        }

        const cash = (promoSelected.cash_promotions || []).map((item: any) => ({
            id: item.id,
            payment_method_id: item.payment_method?.id || item.payment_method_id,
            name: item.payment_method?.payment_method || "Pagamento à vista",
            discount: item.discount,
            installment: null,
            type: 'cash'
        }));

        const credit = (promoSelected.credit_promotions || []).map((item: any) => ({
            id: item.id,
            payment_method_id: item.payment_method?.id || item.payment_method_id,
            name: `Cartão de Crédito (${item.installment}x)`,
            discount: item.discount,
            installment: item.installment,
            type: 'credit'
        }));

        const crediario = (promoSelected.payment_credit_promotion || []).map((item: any) => ({
            id: item.id,
            payment_method_id: item.payment_method?.id || item.payment_method_id,
            name: item.payment_method?.payment_method || "Crediário",
            discount: item.discount,
            installment: null,
            type: 'payment_credit'
        }));

        return [...cash, ...credit, ...crediario];
    };

    // Função para calcular o desconto
    const calculateDiscount = () => {
        const valor = Number(priceProduct) || 0;
        const desconto = discountPersonalized > 0 ? Number(discountPersonalized || 0) : Number(selectedPercent || 0);

        const result = valor - (valor * desconto / 100);
        return result || 0;
    }

    // Função para calcular a taxa
    const calculateTaxa = (
        value: number,
        instalment: number | null,
        card_id: number | null,
    ) => {
        const valor = value || 0;
        const parcela = instalment || 0;
        const id_parcela = card_id || null;

        let interestRate = 0;
        let number_installment = parcela;
        let id_installment = id_parcela;

        if (id_parcela) {
            const value_id_installment = card.find((item) => item.id === id_parcela);
            interestRate = parseFloat(value_id_installment?.interest_rate || '0');
            number_installment = value_id_installment?.number_installment || 0;
        } else {
            const value_id_installment = card.find((item) => item.number_installment === parcela);
            interestRate = parseFloat(value_id_installment?.interest_rate || '0');
            id_installment = value_id_installment?.id || null;
        }

        const total = valor + valor * (interestRate / 100);

        return {
            total,
            interestRate,
            parcela: number_installment,
            id_parcela: id_installment
        };
    };

    // Enviar dados selecionados
    const onSubmit: SubmitHandler<Inputs> = async (data) => {
        startLoading();
        try {

            const promotions = (() => {
                const { promotions } = itemsPromotion;
                return promotions?.promotion_id ? promotions : null;
            })();

            const creditStore = data.payments.down_payment !== '' ?
                {
                    to_receive: data.payments?.to_receive || 0,
                    down_payment: data.payments?.down_payment || 0,
                    first_due_date: data.payments?.first_due_date || '',
                    payment_credit_installment: Number(data.payments?.payment_credit_installment) || 0,
                    down_payments: data.payments?.down_payments && data.payments?.down_payments.length > 0 ?
                        data.payments?.down_payments.map((item) => ({
                            payment_method_id: item.payment_method_id,
                            amount: item.amount || data.payments?.down_payment || 0,
                            name_payment: item.name_payment || '-',
                            installment_on_credit_card_id: item.installment_on_credit_card_id || null,
                            installment_interest_rate: item.installment_interest_rate || 0,
                            parcela: item.number_installment || 0,
                        }))
                        : []
                } : null;

            const updateItemsPromotion = {
                payments: itemsPromotion.payments.map((payment) => {
                    if ((payment.name === 'crediário' || payment.name === "crediário da loja") &&
                        creditStore) {
                        return {
                            ...payment,
                            ...creditStore,
                        };
                    }
                    return payment

                }),
                promotions,
            }

            const downPayment = data.payments?.down_payment || 0;
            const totalPayments = itemsPromotion.payments
                .reduce((acc, payment) => acc + (Number(payment.amount) || 0), 0);

            if (totalPayments !== calculateDiscount()) {
                alert("A soma dos pagamentos não corresponde ao preço do produto!");
                return;
            }

            if ((downPayment < minimumValue) && isAuthValueMinumum === false && creditStore) {
                toggleModalVisibility('auth-valuemin');
                return;
            }

            dataPayment({ ...updateItemsPromotion, user_id: idUser });
            closeModal();
        } catch (error: any) {
            alert(error.message);
        } finally {
            stopLoading();
        }
    };

    // Função para fechar modal
    const closeModal = () => {
        setItemsPromotion({
            promotions: null,
            payments: [],
        });
        setPromoSelected(null);
        setSelectedPercent(0);
        setDiscountPersonalized(0);
        setIdUser(0);
        reset();
        setModalClose();
        setIsAuth(true);
        setIsAuthValueMinumum(false);
    }

    if (isOpenModals) {
        return (
            <LayoutDefault
                setModalClose={closeModal}
                title='Área do Pagamento'
                subTitle='Preencha os dados do pagamento do produto.'
                statusLoad={isLoading}
                submiteModal={handleSubmit(onSubmit)}>
                {isLoadingModal || !data ? (
                    <Loading />
                ) : (
                    <S.Container>
                        <S.Content>
                            <S.Text>
                                Valor do produto: {CurrencyFormat(parseFloat(priceProduct || '0'))}
                            </S.Text>
                            {/* 1.PROMOTIONS Options section */}
                            <S.Section>
                                <S.Title
                                    isOpen={isOpenModal('section-promo')}
                                    onClick={() => handleVisibleSection('section-promo')}
                                >
                                    1. Promoções Disponíveis
                                    {isOpenModal('section-promo') ?
                                        <CaretUp size={14} />
                                        :
                                        <CaretDown size={14} />
                                    }
                                </S.Title>
                                {
                                    isOpenModal('section-promo') &&
                                    <S.listButton>
                                        {
                                            data.length > 0
                                                && data !== undefined ?
                                                data.map((item) => (
                                                    <S.Button
                                                        type='button'
                                                        onClick={() => handlePromotion(item.promotion)}
                                                        className={itemsPromotion.promotions?.promotion_id === item.promotion_id ? 'active' : ''}
                                                    >
                                                        <S.TitleButton>{item.promotion.title}</S.TitleButton>
                                                        <S.ContentButton>
                                                            <S.Infor>
                                                                <S.Text className='subtitle'>
                                                                    Nível de Autorização:
                                                                </S.Text>
                                                                <S.Text>
                                                                    {item.promotion.auth}
                                                                </S.Text>
                                                            </S.Infor>

                                                            <S.Infor>
                                                                <S.Text className='subtitle'>
                                                                    Vendedor:
                                                                </S.Text>
                                                                <S.Text>
                                                                    {item.promotion?.user?.first_name || 'TODOS'}
                                                                </S.Text>
                                                            </S.Infor>
                                                        </S.ContentButton>

                                                        <S.Infor>
                                                            <S.Text>
                                                                Desconto:
                                                            </S.Text>
                                                            <S.Text className='subtitle'>
                                                                {item.promotion.auth !== 'Loja' ?
                                                                    '-' : formatPromotion(item.promotion)
                                                                }
                                                            </S.Text>
                                                        </S.Infor>
                                                    </S.Button>
                                                ))
                                                :
                                                <S.Text className="warning">Nenhuma promoção encontrada!</S.Text>
                                        }
                                    </S.listButton>
                                }
                            </S.Section>

                            {/* 2.PAYMENTS Options section */}
                            <S.Section>
                                <S.Title
                                    onClick={() => handleVisibleSection('section-payment')}
                                    isOpen={isOpenModal('section-payment')}
                                >
                                    2. Forma de Pagamento
                                    {isOpenModal('section-payment') ?
                                        <CaretUp size={14} />
                                        :
                                        <CaretDown size={14} />
                                    }
                                </S.Title>

                                {isOpenModal("section-payment") && isAuth ? (
                                    <S.listButtonPay className="grid">
                                        {getPaymentOptions(promoSelected).map((option) => (
                                            <S.ContentPayment key={`${option.id}-${option.name}`}>
                                                <S.ButtonPayment
                                                    onClick={() => handlePayment(
                                                        option.id,
                                                        option.payment_method_id,
                                                        option.name,
                                                        option.discount,
                                                        option.type,
                                                        option.installment,
                                                    )}
                                                    className={
                                                        itemsPromotion.payments.some(p => p.name === option.name.toLocaleLowerCase())
                                                            ? "active"
                                                            : ""
                                                    }
                                                >
                                                    {option.name}
                                                    <S.highliInfor isActive={true}>{
                                                        formatPercentage(parseFloat(option.discount)) || 0
                                                    }</S.highliInfor>
                                                </S.ButtonPayment>
                                            </S.ContentPayment>
                                        ))}
                                    </S.listButtonPay>
                                ) : null}
                            </S.Section>

                            {/* 3.VALUES distribution section */}
                            <S.Section>
                                <S.Title
                                    onClick={() => handleVisibleSection('values-distribution')}
                                    isOpen={isOpenModal('values-distribution')}
                                >
                                    3. Distribuição de Valores:
                                    {isOpenModal('values-distribution') ?
                                        <CaretUp size={14} />
                                        :
                                        <CaretDown size={14} />
                                    }
                                </S.Title>

                                {isOpenModal('values-distribution') && (
                                    <>
                                        {itemsPromotion.payments.map((payment, index) => (
                                            <S.ContentPayment
                                                className="content-color"
                                                key={index}
                                            >
                                                <S.Header>
                                                    <S.Text className="subtitle-full">
                                                        Valor do {payment.name || 'Forma de pagamento'}
                                                    </S.Text>
                                                    <S.ButtonClose
                                                        onClick={() => handleRemovePayment(index)}
                                                    >
                                                        <X size={16} />
                                                    </S.ButtonClose>
                                                </S.Header>

                                                <S.ContentInput>
                                                    <NumericFormat
                                                        prefix="R$ "
                                                        decimalSeparator=","
                                                        decimalScale={2}
                                                        fixedDecimalScale={true}
                                                        allowNegative={false}
                                                        placeholder="R$ 0,00"
                                                        value={payment.amount ?? ''}
                                                        onValueChange={(values) => {
                                                            const value = values.floatValue ?? 0;

                                                            setItemsPromotion(prev => {
                                                                const updated = [...prev.payments];
                                                                updated[index] = {
                                                                    ...updated[index],
                                                                    amount: value
                                                                };
                                                                return { ...prev, payments: updated };
                                                            });
                                                        }}
                                                    />
                                                </S.ContentInput>

                                                {
                                                    (
                                                        payment.name === "crediário" ||
                                                        payment.name === "crediário da loja"
                                                    )
                                                    && (
                                                        <CreditStorePayment
                                                            setValue={setValue}
                                                            watch={watch}
                                                            getValues={getValues}
                                                            register={register}
                                                            errors={errors}
                                                            reset={reset}
                                                            resetField={resetField}
                                                            control={control}
                                                            minimum_value={minimumValue || '0'}
                                                        />
                                                    )
                                                }

                                                {
                                                    payment.name === "cartão de crédito" &&
                                                    payment.paymentable_type === null && (
                                                        <CreditCard
                                                            register={register}
                                                            errors={errors}
                                                            reset={reset}
                                                            resetField={resetField}
                                                            subtotal={payment.amount || 0}
                                                            index={index}
                                                            responsaData={(
                                                                id, interestRate, parcela
                                                            ) => setItemsPromotion(prev => {
                                                                const updated = [...prev.payments];
                                                                const current = updated[index];

                                                                updated[index] = {
                                                                    ...current,
                                                                    installment_on_credit_card_id: id,
                                                                    taxa: interestRate,
                                                                    parcela: parcela || 0
                                                                };

                                                                return { ...prev, payments: updated };
                                                            })}
                                                        />
                                                    )}
                                            </S.ContentPayment>
                                        ))}
                                    </>
                                )}
                            </S.Section>

                            {/* INPUT DISCOUNT configuration section */}
                            <S.Section>
                                <S.Title
                                    onClick={() => handleVisibleSection('section-manual')}
                                    isOpen={isOpenModal('section-manual')}
                                >
                                    4. Ajustar Desconto (Opcional)
                                    {isOpenModal('section-manual') ?
                                        <CaretUp size={14} />
                                        :
                                        <CaretDown size={14} />
                                    }
                                </S.Title>
                                {
                                    isOpenModal('section-manual') &&
                                    <S.ContentInput>
                                        <S.Text className='subtitle'>
                                            ({`Máximo: ${selectedPercent || 0}%`})
                                        </S.Text>

                                        <S.Input
                                            placeholder='0%'
                                            type='number'
                                            onChange={(e) => {
                                                const value = parseFloat(e.target.value);
                                                if (value >= 0 && value <= selectedPercent) {
                                                    setDiscountPersonalized(value);
                                                    setItemsPromotion((prev) => ({
                                                        ...prev,
                                                        promotions: prev.promotions
                                                            ? {
                                                                ...prev.promotions,
                                                                personalized_discount: e.target.value, // atualiza só esse campo
                                                            }
                                                            : null, // caso não exista promoção
                                                    }));
                                                } else {
                                                    alert(`O desconto deve ser entre 0 e ${selectedPercent || 0}%`);
                                                }
                                            }}
                                        />
                                    </S.ContentInput>
                                }
                            </S.Section>

                            {/* RESUMO */}
                            <S.Footer>
                                <S.ContentInfor>
                                    <S.Text className='subtitle'>
                                        Promoção
                                    </S.Text>
                                    <S.Description>
                                        {itemsPromotion.promotions?.title || "-"}
                                    </S.Description>
                                </S.ContentInfor>

                                <S.ContentInfor>
                                    <S.Text className='subtitle'>
                                        Subtotal
                                    </S.Text>
                                    <S.Description>
                                        {CurrencyFormat(parseFloat(priceProduct || '0'))}
                                    </S.Description>
                                </S.ContentInfor>

                                <S.ContentInfor>
                                    <S.Text className='subtitle'>
                                        Desconto
                                    </S.Text>
                                    <S.Description
                                        className="active">
                                        -{
                                            discountPersonalized > 0 ?
                                                formatPercentage(discountPersonalized || 0) :
                                                formatPercentage(selectedPercent || 0)
                                        }
                                    </S.Description>
                                </S.ContentInfor>

                                <S.ContentInfor>
                                    <S.Text>
                                        Total
                                    </S.Text>
                                    <S.Text>
                                        {CurrencyFormat(calculateDiscount())}
                                    </S.Text>
                                </S.ContentInfor>

                                <S.DescriptionPayment>
                                    <S.Text className='subtitle'>
                                        Forma de Pagamento
                                    </S.Text>
                                    <S.Description className="padding">
                                        {
                                            itemsPromotion.payments.map((val, index) =>
                                                <S.ContentInfor className="no-border">
                                                    <p>
                                                        {val.name?.toLocaleUpperCase() || '-'}
                                                    </p>
                                                    <p>
                                                        {CurrencyFormat(calculateTaxa(
                                                            val.amount || 0,
                                                            val.parcela || 0,
                                                            val.installment_on_credit_card_id || 0,
                                                        ).total)}
                                                    </p>
                                                </S.ContentInfor>
                                            )
                                        }
                                    </S.Description>
                                </S.DescriptionPayment>
                            </S.Footer>
                        </S.Content>

                    </S.Container>
                )
                }
                <AuthPromotion
                    isOpenModalAuth={isOpenModal("auth-promo")}
                    setModalClose={() => toggleModalVisibility("auth-promo")}
                    onAuthSuccess={handleAuthSuccess}
                />

                <AuthPromotion
                    isOpenModalAuth={isOpenModal("auth-valuemin")}
                    setModalClose={() => toggleModalVisibility("auth-valuemin")}
                    onAuthSuccess={handleAuthSuccessMinumum}
                />
            </LayoutDefault >
        )
    }
    return null;
}